/* eslint-disable camelcase */
import { DaoModel } from '@dynameat/models';
import { MenuProductChange } from './menuProductChange';
import { ProductRecommendation } from './productRecommendation';

export class SubsectionRecommendation extends DaoModel {
  constructor(guid, order, products, nameAlt1, nameAlt2, nameAlt3) {
    super(guid);
    this.order = order || 0;
    this.products = products || [];
    this.nameAlt1 = nameAlt1 || '';
    this.nameAlt2 = nameAlt2 || '';
    this.nameAlt3 = nameAlt3 || '';
  }

  static toInstance(props = {}) {
    const products = ProductRecommendation.toInstanceList(props.products);
    return new SubsectionRecommendation(props.guid, props.order, products, props.name_alt1, props.name_alt2, props.name_alt3);
  }

  serialize() {
    return {
      ...super.serialize(),
      name_alt1: this.nameAlt1,
      name_alt2: this.nameAlt2,
      name_alt3: this.nameAlt3,
      order: this.order,
      products: this.products.map((product) => product.serialize()),
    };
  }

  get name() {
    return this.nameAlt1;
  }

  getVisibleProductsLength() {
    return this.products.filter((p) => p.is_visible).length;
  }

  hasChange() {
    return this.products.some((p) => p.hasChange());
  }

  getChanges(serviceGuid, groupCodeName) {
    // Extract product changes
    return this.products.reduce((changes, product) => {
      if (product.hasChange()) {
        changes.push(new MenuProductChange(product.guid, serviceGuid, groupCodeName, product.order, product.is_visible, product.special, product.special_frame));
      }
      return changes;
    }, []);
  }
}
